import { render, staticRenderFns } from "./claustro.vue?vue&type=template&id=bfb3e030&"
import script from "./claustro.component.ts?vue&type=script&lang=ts&"
export * from "./claustro.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports